import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import ReactPaginate from "react-paginate";
import { imgPath } from "../../utils/imagePath";
import { Tooltip } from "@mui/material";
import config from "../../config";
import UserSidebar from "../../Component/UserSidebar";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { useDispatch, useSelector } from "react-redux";
import {
  saveSelectMentor,
  saveWaitlistMentor,
  getSelectedMentorCount,
  updateUserData,
  loadRegSuggestedMentors,
} from "./Slice/MenteeDashboardSlice";
import { getSubdomainPath, getTranslation } from "../../utils/helpers";
import Details from "../Mentors/details";

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

function SidebarRemoveClass() {
  document.getElementById("OnscrollBody").classList.remove("show_sidebar");
}

const Index = () => {

  const history = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { mentorsData, pagination, isProcessing, mentorsLoading } = useSelector((state) => state.menteeDashboard);

  const { userInfo, isAuth, setting } = useSelector((state) => ({
    userInfo: state.userInfo,
    isAuth: state.isAuth,
    setting: state.setting,
  }));


  const [count, setCount] = useState(0);
  const [chooseMentors, setChooseMentors] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [userData, setUserData] = useState({});
  const [viewPage, setViewPage] = useState(0);
  const [role_active_user] = useState('active_mentor');
  const [mentalHealth, setMentalHealth] = useState("");
  const [certifiedCoach, setCertifiedCoach] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  console.log("", count, chooseMentors)
  const subDomainPath = getSubdomainPath();

  const params = new URLSearchParams(location.search);

  const getRequestCount = useCallback((showPopup = false) => {
    const userId = userInfo.id ? userInfo.id : "";
    if (userId !== '') {
      agent
        .get(API.GETSELECTEDMENTORCOUNT + "/" + userInfo.id)
        .then((res) => {
          setCount(res.data.data);
        })
        .catch((err) => {
          setPopupMessage(err.message);
          setShowPopup(true);
        });
    }
  }, [userInfo]);

  const getSelectedMentors = () => {
    const userId = userInfo.id ? userInfo.id : "";
    const request = {};
    request.userId = userId;
    agent
      .post(API.GETCHOOSENMENTORS, request)
      .then((res) => {
        setChooseMentors(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getMentor = async (e, mentorId) => {
    e.preventDefault();

    if (!isAuth) {
      const message = "Thank you for browsing! Help us create a meaningful mentoring engagement for you by registering in one simple step, or login if you already have an account.";
      setPopupMessage(message);
      setShowPopup(true);
      // Redirect after popup shows briefly (e.g. 2 seconds)
      setTimeout(() => {
        history("/login");
      }, 2000);
      return;
    }

    try {
      const res = await dispatch(
        saveSelectMentor({ userId: userInfo.id, mentorId })
      ).unwrap();

      // Since the slice returns res.data directly, the message should be at res.message
      const message = res?.message || "Record has been updated successfully.";
      setPopupMessage(message);
      setShowPopup(true);
      dispatch(getSelectedMentorCount(userInfo.id));
    } catch (err) {
      console.error('saveSelectMentor API Error:', err);
      setPopupMessage(err.message || "Something went wrong. Please try again.");
      setShowPopup(true);
    }
  };

  useEffect(() => {
    dispatch(updateUserData());
  }, [dispatch]);

  const setMentorWaitlistAvailability = async (e, mentorId) => {
    e.preventDefault();
    const userId = userInfo.id;
    const request = {};
    request.userId = userId;
    request.mentorId = mentorId;
    try {
      const res = await dispatch(
        saveWaitlistMentor({ userId: userInfo.id, mentorId })
      ).unwrap();

      // Since the slice returns res.data directly, the message should be at res.message
      const message = res?.message || "Added to waitlist.";
      setPopupMessage(message);
      setShowPopup(true);
    } catch (err) {
      console.error('saveWaitlistMentor API Error:', err);
      const errorMessage = err?.message || "Failed to waitlist.";
      setPopupMessage(errorMessage);
      setShowPopup(true);
    }
  };


  // Updated: Fetch mentor detail and merge reg_fields/reg_feilds for dynamic labels
  const getUserDetails = async (e, item) => {
    e.preventDefault();
    try {
      const { loadMentorDetail } = await import("../Mentors/Slice/mentorsSlice");
      const detail = await dispatch(
        loadMentorDetail({ mentorId: item.id })
      ).unwrap();
      setUserData({
        ...item,
        ...detail,
        reg_fields: detail?.reg_fields || item?.reg_fields,
        reg_feilds: detail?.reg_feilds || item?.reg_feilds,
      });
    } catch {
      setUserData(item);
    }
    setModalShow(true);
  };

  useEffect(() => {
    getSelectedMentors();
  }, []);


  useEffect(() => {
    const request = { page_type: "suggested_mentors" };
    getRequestCount(false); // no popup on page load
    document.title = "Suggested Mentors";

    const params = new URLSearchParams(location.search);

    if (isAuth && userInfo?.experience_levels?.length > 0) {
      request.experience_levels = userInfo.experience_levels[0].id;
    }
    if (params.get("page")) {
      request.page = params.get("page");
    }
    if (params.get("mf_mental_health")) {
      const mf_mental_health = params.get("mf_mental_health");
      setMentalHealth(mf_mental_health);
      request.mf_mental_health = mf_mental_health;
    }
    if (params.get("lgbtq_discussion")) {
      request.lgbtq_discussion = params.get("lgbtq_discussion");
    }
    if (params.get("mf_certified_coach")) {
      const mf_certified_coach = params.get("mf_certified_coach");
      setCertifiedCoach(mf_certified_coach);
      request.mf_certified_coach = mf_certified_coach;
    }
    dispatch(
      loadRegSuggestedMentors({
        request,
        user_id: userInfo.id,
        role_id: "Mentor",
        domains: userInfo.domains,
        programmes: userInfo.programmes,
        board_entity_type: userInfo.board_entity_type,
        board_entity_type_2: userInfo.board_entity_type_2,
        ...(subDomainPath === "siddev" || subDomainPath === "siduat" || subDomainPath === "sid") && {
          years_of_board_experience: userInfo.years_of_board_experience,
          objective: userInfo.objective,
        },
      })
    );
  }, [dispatch, userInfo, getRequestCount, location]);

  const handlePageClick = (data) => {
    setViewPage(data.selected);
    let page = data.selected + 1;
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    history({
      search: "?" + params,
    });
    window.scrollTo(0, 0);
  };

  const setSelectedHealth = (e, type) => {
    const val = e.target.checked;

    if (type === "mf_mental_health") {
      if (val) {
        params.set("mf_mental_health", 1);
        setMentalHealth(1);
      } else {
        params.set("mf_mental_health", "");
        setMentalHealth("");
      }
    }


    if (type === "mf_certified_coach") {
      if (val) {
        params.set("mf_certified_coach", 1);
        setCertifiedCoach(1);
      } else {
        params.set("mf_certified_coach", "");
        setCertifiedCoach("");
      }
    }
    // Set parameter for searching data
    if (params.get("page") > 1) {
      params.set("page", 1);
    }
    history({
      search: "?" + params,
    });
  };

  // const getFieldValueAndStatus = (field) => {
  //   return setting?.mentor_fields_json?.find(item => item.field === field)?.value === "Yes";
  // };

  const getFieldValueAndStatus = (item, field) => {
    if (!item) return false;

    if (field === "name") {
      const firstName = item?.reg_fields?.first_name || item?.first_name;
      const lastName = item?.reg_fields?.last_name || item?.last_name;
      const fullName =
        item?.reg_fields?.full_name ||
        [firstName, lastName].filter(Boolean).join(" ");

      return (
        fullName !== null &&
        fullName !== undefined &&
        fullName !== "" &&
        fullName !== "null" &&
        fullName !== "undefined"
      );
    }

    let value = item?.reg_fields?.[field] ?? item?.[field];

    if (value === undefined && field === "objective") {
      value = item?.all_objective;
    }

    return (
      value !== null &&
      value !== undefined &&
      value !== "" &&
      value !== "null" &&
      value !== "undefined"
    );
  };

  const getDynamicFieldValue = (item, key) => {
    if (item?.reg_fields && Object.hasOwn(item.reg_fields, key)) {
      return item.reg_fields[key];
    }
    return item?.[key];
  };

  const isEmptyValue = (value) => {
    return (
      value === null ||
      value === undefined ||
      value === "" ||
      value === "null" ||
      value === "undefined"
    );
  };

  const getFallbackField = (item, key) => {
    const value = item?.[key];
    if (isEmptyValue(value)) {
      return getDynamicFieldValue(item, key);
    }
    return value;
  };

  const renderCardRegFields = (item) => {
    const regFields = item?.reg_fields;
    if (!regFields || typeof regFields !== "object") return null;

    const dedicatedCardFields = new Set([
      "image",
      "is_privacy",
      "first_name",
      "last_name",
      "position",
      "organization",
      "full_name",
      "country",
      "country_image_path",
      "main_area",
      "all_main_area",
      "all_sub_area",
    ]);

    return Object.entries(regFields).map(([key, value]) => {
      if (dedicatedCardFields.has(key)) return null;
      if (!value || value === "null" || value === "undefined") return null;
      if (key === "domains") {
        value = value.split("||")[0];
      }
      return (
        <h5 key={key} className={`reg-field reg-field--${key}`}>
          {value}
        </h5>
      );
    });
  };

  const getRegFieldValueAndStatus = (field, active_user) => {
    return setting?.registration_steps_fields?.find(item => item.reg_key === field)?.status === 1;
  };

  const getAvailabilityBadge = (item) => {
    if (
      item?.is_reached_limit === 0 &&
      item?.user_availability_check?.availability === 1
    ) {
      return <span className="AvailabilityStatus m-3">Available</span>;
    }

    return <span className="UnavailabilityStatus m-3">Unavailable</span>;
  };

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />

        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <h1 className="dash_heading">Suggested Mentors</h1>
          <div className="seprator health_check">
            <ul className="d-flex align-items-center me-2 mb-3">
              {(getRegFieldValueAndStatus('mf_mental_health', role_active_user) || getRegFieldValueAndStatus('mf_certified_coach', role_active_user)) && <li className="ms-3 text-dark">Filters</li>
              }
              {getRegFieldValueAndStatus('mf_mental_health', role_active_user) &&
                <li className="ms-3 mr-md-5">
                  <span className="custom_check">
                    &nbsp;{" "}
                    <input
                      value={mentalHealth ? 1 : 0}
                      type="checkbox"
                      onClick={(e) => setSelectedHealth(e, "mf_mental_health")}
                      defaultChecked={params.get("mf_mental_health") || mentalHealth}
                    />
                    <span className="check_indicator">&nbsp;</span>
                  </span>
                  <Tooltip
                    size="4xl"
                    title={<h5>{config?.mf_mental_health}</h5>}
                    describeChild
                    arrow
                  >
                    <img alt="" src={imgPath + "usermind.svg"} />
                  </Tooltip>{" "}
                </li>
              }
              {getRegFieldValueAndStatus('mf_certified_coach', role_active_user) &&
                <li className="ms-3 mr-md-5">
                  <span className="custom_check">
                    &nbsp;{" "}
                    <input
                      type="checkbox"
                      value={certifiedCoach}
                      onClick={(e) => setSelectedHealth(e, "mf_certified_coach")}
                      defaultChecked={Boolean(params.get("mf_certified_coach") || certifiedCoach)}

                    />
                    <span className="check_indicator">&nbsp;</span>
                  </span>
                  <Tooltip
                    size="4xl"
                    title={<h5>{config?.mf_certified_coach}</h5>}
                    describeChild
                    arrow
                  >
                    <img alt="" src={imgPath + "useraward.svg"} />
                  </Tooltip>{" "}
                </li>
              }
            </ul>
          </div>
          <div className="box_wrap shadow-sm bg-white mentor_box">
            {mentorsLoading ? (
              <div className="text-center py-5">
                <p className="mt-3">Loading mentors...</p>
              </div>
            ) : (
              <>
                {mentorsData?.length ? <h3 className="">
                  {/* Here is a list of fab mentors based on your selected domains & objectives. Please indicate your preference for up to 5 mentors. We will try our best to assign a mentor of your choice. */}
                  {setting?.suggested_mentor_text || getTranslation("suggested_mentor_text")}
                </h3> : <div className="text-center">No suggested mentor found.</div>}
                {userInfo?.programmes == 20 && <h3 className="text-dark">
                  <Link to={{
                    pathname: '/ignite-women-mentoring',
                    state: 'ignite-women-mentoring',
                  }} target="_blank" >
                    Browse through the complete list of IGNITE Mentors.
                  </Link>
                </h3>}
                <div className="mentor_list dash_MentorList">
                  {/* {mentorsData && */}
                  {mentorsData.map((item, key) => (
                    <div className="menteesCols" key={item.id}>
                      <div className="outer position-relative">
                        <div className="mentor_img">
                          {getAvailabilityBadge(item)}
                          {getFallbackField(item, "image") ? (
                            <img
                              src={getFallbackField(item, "image")}
                              alt="career mentoring program"
                            />
                          ) : (
                            <img
                              src={imgPath + "mentor_women_two.png"}
                              alt="best career mentoring program"
                            />
                          )}
                        </div>
                        <div className="mentor_info">
                          <div className="">
                            <span>
                              {item?.reg_fields?.country &&
                                item?.country_image_path && (
                                  <span>
                                    <img
                                      src={item.country_image_path}
                                      alt={item.reg_fields.country}
                                      className="country_flag"
                                    />
                                  </span>
                                )}
                              {/* Full name — structural */}
                              {(item?.reg_fields?.full_name ||
                                item?.full_name ||
                                item?.reg_fields?.first_name ||
                                item?.reg_fields?.last_name) && (
                                  <h3>
                                    {item?.reg_fields?.full_name ||
                                      item?.full_name ||
                                      `${item?.reg_fields?.first_name || ""} ${item?.reg_fields?.last_name || ""}`.trim()}
                                  </h3>
                                )}

                            </span>
                          </div>
                          <h6>{getFallbackField(item, "position")}</h6>
                          <p>
                            {getFallbackField(item, "organization")
                              ? getFallbackField(item, "organization")
                              : ""}
                          </p>
                          {getFieldValueAndStatus('domains') && (getFallbackField(item, "main_area") || getFallbackField(item, "all_main_area")) && (
                            <p>{getFallbackField(item, "main_area") || getFallbackField(item, "all_main_area")}</p>
                          )}
                          {renderCardRegFields(item)}
                        </div>
                        <div className="mentor_btn">
                          <div>
                            {userInfo.role_id !== "Mentor" &&
                              item.is_relationship === 0 &&
                              item.is_mentor_terminate === 0 &&
                              item.is_same_program === 1 && (
                                <>
                                  {item.is_reached_limit === 0 &&
                                    item?.user_availability_check?.availability === 1 ? (
                                    <Link
                                      to=""
                                      onClick={(e) => {
                                        getMentor(
                                          e,
                                          item.id,
                                        );
                                      }}
                                    >
                                      Indicate as Preferred Mentor
                                    </Link>
                                  ) : (
                                    <Link
                                      to=""
                                      onClick={(e) => {
                                        setMentorWaitlistAvailability(
                                          e,
                                          item.id
                                        );
                                      }}
                                    >
                                      Waitlist for availability
                                    </Link>
                                  )}
                                </>
                              )}
                            <Link
                              to=""
                              id={key}
                              onClick={(e) => {
                                getUserDetails(
                                  e,
                                  item
                                );
                              }}
                            >
                              {"Read More"}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {(mentorsData?.length && pagination.total_pages) ? (
                  <ReactPaginate
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    forcePage={viewPage}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={pagination.total_pages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={pagination.per_page}
                    onPageChange={(v) => handlePageClick(v)}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                  />
                ) : ''}
              </>
            )}
          </div>
        </div>
      </div>

      <button
        type="button"
        className="sidebar_overlay"
        onClick={SidebarRemoveClass}
        aria-label="Close sidebar overlay"
      />


      {modalShow && (
        <Details
          getFieldValueAndStatus={getFieldValueAndStatus}
          show={modalShow}
          setting={setting}
          userdata={userData}
          onHide={() => setModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

      {/* Full Screen Loader */}
      {isProcessing && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <i
            className="fas fa-spinner fa-spin"
            style={{
              fontSize: '50px',
              color: '#007bff'
            }}
          ></i>
        </div>
      )}
    </div>
  );
};

export default Index;
